import React, { forwardRef } from 'react';
import './Input.css';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  fullWidth?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label, error, hint, icon, iconRight, fullWidth = true,
  className = '', id, ...props
}, ref) => {
  const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <div className={`ui-input-group ${fullWidth ? 'ui-input-full' : ''} ${error ? 'ui-input-error' : ''} ${className}`}>
      {label && <label htmlFor={inputId} className="ui-input-label">{label}</label>}
      <div className="ui-input-wrapper">
        {icon && <span className="ui-input-icon">{icon}</span>}
        <input ref={ref} id={inputId} className={`ui-input ${icon ? 'has-icon' : ''} ${iconRight ? 'has-icon-right' : ''}`} {...props} />
        {iconRight && <span className="ui-input-icon-right">{iconRight}</span>}
      </div>
      {error && <span className="ui-input-error-text">{error}</span>}
      {hint && !error && <span className="ui-input-hint">{hint}</span>}
    </div>
  );
});
Input.displayName = 'Input';
